<script lang="ts" setup>
  import { pickLocalizedText, useCloudStatusStore } from '@/stores/cloudStatus';
  import { isSafeUrl } from '@/utils/branding';

  const { notice, dismiss } = useCloudStatusStore();

  const statusUrl = (window.__VITE_ENVS.SERVICE_STATUS_URL as string) ?? '';
  const statusLink = isSafeUrl(statusUrl) ? statusUrl : '';

  const { t, locale } = useI18n({
    messages: {
      ru: { details: 'Подробнее о состоянии сервисов' },
      en: { details: 'More about the state of our services' },
    },
  });

  const title = computed(() =>
    notice.value ? pickLocalizedText(notice.value.title, locale.value) : '',
  );
  const text = computed(() =>
    notice.value ? pickLocalizedText(notice.value.text, locale.value) : '',
  );
</script>

<template>
  <VMessage
    v-if="notice"
    :key="notice.key"
    data-testid="cloud-status-banner"
    closable
    :severity="notice.severity"
    @close="dismiss">
    <div class="grid gap-4">
      <span v-if="title" data-testid="cloud-status-title" class="font-bold">{{
        title
      }}</span>
      <span v-if="text" data-testid="cloud-status-text" class="whitespace-pre-line">{{
        text
      }}</span>
      <a
        v-if="statusLink"
        class="link"
        target="_blank"
        rel="noopener noreferrer"
        :href="statusLink">{{ t('details') }}</a>
    </div>
  </VMessage>
</template>
